import { ref, reactive } from 'vue'

const isBannerVisible = ref(false)

// État global du consentement
const consent = reactive({
  necessary: true,
  analytics: false,
  marketing: false,
  preferences: false,
})

export function useCookieConsent() {
  const openBanner = () => {
    isBannerVisible.value = true
  }

  const closeBanner = () => {
    isBannerVisible.value = false
  }

  const getConsent = () => consent

  const updateConsent = (newConsent: Partial<typeof consent>) => {
    Object.assign(consent, newConsent)
  }

  return {
    isBannerVisible,
    openBanner,
    closeBanner,
    getConsent,
    updateConsent,
  }
} 